import React, { useState, useEffect } from 'react';

import Colores_progreso from '../../reportes/vivero/components/Colores_progreso';
const ContenedorDeAvance = (p) => {
    const data = p.data;
    const meta = data.lunes_plan + data.martes_plan + data.miercoles_plan + data.jueves_plan + data.viernes_plan + data.sabado_plan;
    const realizado = data.lunes_ejecutado + data.martes_ejecutado + data.miercoles_ejecutado + data.jueves_ejecutado + data.viernes_ejecutado + data.sabado_ejecutado;
    const avance_porcentual = meta > 0 ? +(realizado / meta * 100).toFixed(2) : 0;

    const color_percent = (avance) => {
        if (avance == 0) return '#F02C00';
        if (avance < 30) return '#FC6903';
        if (avance < 50) return '#FC9603';
        if (avance < 70) return '#F3FF00';
        if (avance < 90) return '#AEFF00';
        if (avance <= 100) return '#02D61C';
        return '#00BDFF';
    }

    if (meta === 0) return (
        <div className='wpx-400 text-400 '>
            <div className='row justify-content-between w-100 m-0 p-0'>
                <div className='col-auto text-s text-start p-0 m-0'>{data.labor} °°° <span className='text-xs'>Sin actividad planeada</span></div>
            </div>
        </div>
    );

    return (
        <div className='wpx-400 text-400 '>
            <div className='w-100 m-0' style={{ backgroundColor: '#c2c2c2' }}>
                <div className='row justify-content-start w-100 m-0 p-0 border round-l'>
                    <div className='m-0 ' style={{ padding: '2px', width: `${avance_porcentual > 100 ? 100 : avance_porcentual}%`, backgroundColor: color_percent(avance_porcentual) }}></div>
                </div>
            </div>
            <div className='row justify-content-between w-100 m-0 p-0'>
                <div className='col-auto text-s text-start p-0 m-0'>{data.labor}</div>
                <div className='col-auto m-0 p-0 text-end text-bold bw'>{avance_porcentual}%</div>
            </div>
        </div>
    )
}

export default ContenedorDeAvance;